<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称">
            <a-input :read-only="this.params.isShow" placeholder="请输入产品名称" v-decorator="[
          'productName',
          {initialValue:data.productName,rules: [{ required: true, message: '请输入产品名称' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编码">
            <a-input :read-only="true" placeholder="保存后自动生成" v-decorator="[
          'productCode',
          {initialValue:data.productCode,rules: [{ required: false, message: '请输入产品编码' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格">
            <a-input :read-only="this.params.isShow" placeholder="请输入规格" v-decorator="[
          'specDes',
          {initialValue:data.specDes,rules: [{ required: false, message: '请输入规格' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="长">
            <a-input :read-only="this.params.isShow" placeholder="请输入长" v-decorator="[
          'length',
          {initialValue:data.length,rules: [{ required: false, message: '请输入长' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="宽">
            <a-input :read-only="this.params.isShow" placeholder="请输入宽" v-decorator="[
          'width',
          {initialValue:data.width,rules: [{ required: false, message: '请输入宽' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="高">
            <a-input :read-only="this.params.isShow" placeholder="请输入高" v-decorator="[
          'height',
          {initialValue:data.height,rules: [{ required: false, message: '请输入高' }]}]"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="体积">
            <a-input :read-only="this.params.isShow" placeholder="请输入体积" v-decorator="[
          'volume',
          {initialValue:data.volume,rules: [{ required: false, message: '请输入体积' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="重量">
            <a-input :read-only="this.params.isShow" placeholder="请输入重量" v-decorator="[
          'weight',
          {initialValue:data.weight,rules: [{ required: false, message: '请输入重量' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="单位" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select placeholder="请选择单位" :disabled="this.params.isShow" :options="this.measureUnitOptions" v-decorator="['measureUnitId',{initialValue:data.measureUnitId,rules: [{ required: true, message: '请选择单位'}]}]"></a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品系列">
            <a-select placeholder="" :disabled="this.params.isShow" :options="this.productSeriesOptions" v-decorator="['productSeriesId',{initialValue:data.productSeriesId,rules: [{ required: true, message: '请选择产品系列'}]}]"></a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品分类">
            <a-cascader placeholder="请选择产品分类" expandTrigger="hover" @change="categoryChange" :options="this.allCategory" v-decorator="['category',{initialValue:category,rules: [{ required: true, message: '请选择产品分类'}]}]"></a-cascader>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计交期">
            <a-input :read-only="this.params.isShow" type="number" :min="0" placeholder="请输入预计交期" v-decorator="[
          'expectedDelivery',
          {initialValue:data.expectedDelivery,rules: [{ required: true, message: '请输入预计交期' }]}]" addonAfter="天"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-form-item label="产品图片" :labelCol="{
        xs: { span: 24 },
        sm: { span: 2 }
      }" :wrapperCol="{
        xs: { span: 24 },
        sm: { span: 22 }
      }">
          <div class="clearfix">
            <upload-image @uploadChange="uploadChange" :fileListInit="fileList" :imageCount="5" @cancelFile="cancelFile" :multiple="true" v-decorator="[
          'fileList',
          {rules: [{ required: false,message:'请上传图片' , whitespace: true,},{validator: validate}] }]"></upload-image>
          </div>
        </a-form-item>
      </a-row>
      <a-row class="form-row">
        <a-form-item label="产品介绍" :labelCol="{
        xs: { span: 24 },
        sm: { span: 2 }
      }" :wrapperCol="{
        xs: { span: 24 },
        sm: { span: 22 }
      }">
          <div class="hp-editor">
            <script id="editor" ref="editor" type="text/plain"></script>
          </div>
        </a-form-item>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  productName: "",
  productCode: "",
  specDes: "",
  productSeriesId: undefined,
  volume: "",
  weight: "",
  measureUnitId: undefined,
  expectedDelivery: ""
};
export default {
  name: "hp-manager-page-product-add",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      productSeriesOptions: [],
      allCategory: [],
      measureUnitOptions: [],
      fileList: [],
      description: "",
      category: []
    };
  },

  async mounted() {
    if (this.params.id) {
      await this.getProduct();
    } else {
      this.data = exzends(defaultData);
    }
    this.getProductSeries();
    this.getAllCategory();
    this.getMeasureUnitOptions();
    this.initUeditor();
  },
  destroyed() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    initUeditor() {
      this.editor = UE.getEditor("editor", {
        initialFrameWidth: 1000,
        initialFrameHeight: 400
      }); // 初始化UE
      this.editor.addListener("ready", () => {
        this.editor.setContent(this.description || ""); // 确保UE加载完成后，放入内容。
      });
    },
    //图片改变
    uploadChange(fileList) {
      this.fileList = fileList;
    },
    cancelFile(fileList) {
      this.fileList = fileList;
    },
    categoryChange(option) {
      this.data.firstCategoryId = parseInt(option[0]);
      if (option[1]) {
        this.data.sencondCategory = parseInt(option[1]);
      }
    },
    async getMeasureUnitOptions() {
      let dictionary = await api.GetDictionaryForSelect({ type: 1 });
      if (dictionary) {
        dictionary.forEach(a => {
          this.measureUnitOptions.push({
            label: a.text,
            value: a.value,
            disabled: a.disabled
          });
        });
      }
    },
    async getAllCategory() {
      let categoryList = await api.GetAllProductCategoryForCascader();
      if (categoryList) {
        this.allCategory = categoryList;
      }
    },
    categoryChange(option) {
      this.data.firstCategoryId = parseInt(option[0]);
      if (option[1]) {
        this.data.sencondCategory = parseInt(option[1]);
      }
    },
    async getProductSeries() {
      let dictionary = await api.GetDictionaryForSelect({ type: 4 });
      this.productSeriesOptions = [];
      if (dictionary) {
        dictionary.forEach(a => {
          this.productSeriesOptions.push({
            label: a.text,
            value: a.value,
            disabled: a.disabled
          });
        });
      }
    },
    async getProduct() {
      this.loading = true;
      let result = await api.GetProduct({
        id: this.params.id
      });
      if (result) {
        this.data = result;
        this.data.productSeriesId =
          this.data.productSeriesId > 0
            ? this.data.productSeriesId + ""
            : undefined;
        this.data.expectedDelivery = this.data.expectedDelivery + "";
        this.data.measureUnitId =
          this.data.measureUnitId == null
            ? undefined
            : this.data.measureUnitId + "";
        this.category = [
          this.data.parentProductCategoryId > 0
            ? this.data.parentProductCategoryId + ""
            : undefined,
          this.data.productCategoryId > 0
            ? this.data.productCategoryId + ""
            : undefined
        ];
        this.categoryChange(this.category);
        this.description = this.data.introduction;
        if (result.pictureList) {
          let i = 1;
          result.pictureList.forEach(a => {
            this.fileList.push({
              uid: Math.random().toString(),
              name: i + "",
              status: "done",
              url: a
            });
            i++;
          });
          this.$emit("uploadChange", this.fileList);
        }
      }
      console.log(this.defaultValue);
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        id: this.data.id,
        productName: value.productName,
        productCode: value.productCode,
        specDes: value.specDes,
        productSeriesId: parseInt(value.productSeriesId),
        volume: value.volume,
        weight: value.weight,
        length: value.length,
        width: value.width,
        height: value.height,
        measureUnitId: parseInt(value.measureUnitId),
        expectedDelivery: value.expectedDelivery,
        productCategoryId: this.data.sencondCategory,
        introduction: this.editor.getContent(),
        pictureList: []
      };
      this.fileList.forEach(a => {
        result.pictureList.push(a.url);
      });
      return result;
    },
    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let data;
        let requestData = this.dataToPostData(valid.values);
        if (this.params.id > 0) {
          data = await api.UpdateBomProduct(requestData);
          if (data) {
            this.$message.success("修改成功");
            this.$emit("submit-success");
          }
        } else {
          data = await api.CreateBomProduct(requestData);
          if (data) {
            this.$message.success("新增成功");
            this.$emit("submit-success");
          }
        }
        console.log(requestData);
      }
      this.loading = false;
    },
    validate(rule, value, callback) {
      if (this.fileList.length < 0) callback("至少传入一张产品图片");
      callback();
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Goods/BomProduct/Add.vue